/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * UpSmith Dev API
 * OpenAPI spec version: 1.0.0
 */

export type BrandTheme = (typeof BrandTheme)[keyof typeof BrandTheme];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrandTheme = {
  default: "default",
  pink: "pink",
} as const;
